'use client';
import { normalize, schema } from 'normalizr';
import { dryFetch } from '../../utils/dryFetch';
import { getOwnerID } from '../../utils/DryCookies';
import logger from '../../logger';

const labelsSchema = new schema.Entity('labels', {}, { idAttribute: 'label_id' });
const labelsListSchema = new schema.Array(labelsSchema);

/**
 * Fetch labels from the cloud API and return a normalized dictionary.
 * @returns {Promise<Object>} { [label_id]: labelObject }
 */
export const fetchLabelsFromCloud = async () => {
  const ownerID = getOwnerID();
  if (!ownerID) return {};

  try {
    const json = await dryFetch({
      name: 'fetchLabels',
      path: `/labels/${ownerID}`,
    });
    const list = Array.isArray(json) ? json : json?.labels ?? [];
    const normalized = normalize(list, labelsListSchema);
    return normalized.entities.labels ?? {};
  } catch (error) {
    logger.error(error, 'fetchLabelsFromCloud failed');
    throw error;
  }
};
